module.exports = {
  write(name, value, days, domain, path) {
    const date = new Date()
    days = days || 730 // two years
    path = path || '/'
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = `; expires=${date.toGMTString()}`
    let cookieValue = `${name}=${value}${expires}; path=${path}`
    if (domain) {
      if (domain.charAt(0) !== '.') {
        cookieValue += `; domain=.${domain}`
      } else {
        cookieValue += `; domain=${domain}`
      }
    }
    document.cookie = cookieValue
  },
  read(name) {
    const allCookie = `${document.cookie}`
    const index = allCookie.indexOf(name)
    if (name === undefined || name === '' || index === -1) return ''
    let ind1 = allCookie.indexOf(';', index)
    if (ind1 == -1) ind1 = allCookie.length
    return unescape(allCookie.substring(index + name.length + 1, ind1))
  },
  remove(name) {
    if (this.read(name)) {
      this.write(name, '', -1, '/')
    }
  },
}
